'use strict';

angular.module('licensure.services')
    .factory('FBConditions', ['$http', '$q', 'Triggers', 'FBQuestionCriteria', function ($http, $q, Triggers, FBQuestionCriteria) {
        var get = function (args) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/fbconditions/', {
                params: args
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                    d.resolve(null);
                });

            return d.promise;
        }

        return {
            get: get,

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/fbconditions/' + id, {
                    params: {
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },

            save: function (condition) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/fbconditions/';
                if (!isUndefined(condition.id)) {
                    method = 'PUT';
                    url += condition.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        condition: condition
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    // handle error
                    d.resolve(null);
                });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/fbconditions/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            evaluate: function (formID, responseID, licenseRequestID) {
                var d = $q.defer();

                get({ formID: formID, responseID: responseID }).then(function (conditions) {
                    if (conditions != null) {
                        var success = true;
                        var hitCondition = false;
                        conditions.forEach(function(condition) {
                            var result = FBQuestionCriteria.evaluateCondition(condition);
                            if (result != null) {
                                if (result) {
                                    hitCondition = true;
                                    Triggers.fire({
                                        name: condition.trigger_name,
                                        licenseRequestID: licenseRequestID,
                                        triggerID: condition.trigger_id
                                    });
                                }
                            } else {
                                success = false;
                            }
                        });
                        if (!hitCondition) {
                            // Fired if no conditions are met
                            Triggers.fire({
                                name: "Form Conditions Passed Successfully",
                                licenseRequestID: licenseRequestID
                            });
                        }
                        d.resolve(success);
                    }
                    else {
                        d.resolve(false);
                    }
                })

                return d.promise;
            }
        }
    }])
;